import React, { useState, useRef, useEffect } from "react";
import {Link} from 'react-router-dom';

function Footer(props) {
  return (
    <>
      <div className="footer">
            <div className="bg-black">
                <div className="d-flex flex-wrap">
                    <div className="me-4"><Link to="/privacy-policy">Privacy Policy</Link></div>
                    <div className="me-4"><Link to="/terms-condition">Terms and Condition</Link></div>
                    <div className="me-4"><Link to="/faq">FAQ's</Link></div>
                </div>
                <div className="cr-text">
                    <span>Copyright Wayfengshui Group</span>
                </div>
            </div>            
      </div>
    </>
  );
}

export default Footer;
